module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_en-ab82a48adaa8ea1bd2273b72af425dea.jpg";